import { Link } from 'react-router-dom'
import { useSeo } from '../hooks/useSeo'

export default function NotFoundPage() {
  useSeo({ title: 'Page Not Found', noindex: true })
  return (
    <div className="min-h-screen flex items-center justify-center py-24">
      <div className="text-center">
        <div className="font-display text-9xl font-bold text-brand-purple/20 mb-4">404</div>
        <h1 className="font-display text-3xl font-bold text-white mb-3">Page Not Found</h1>
        <p className="text-brand-gray mb-8">The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-primary">Go Home</Link>
          <Link to="/catalogue" className="btn-secondary">Browse Catalogue</Link>
        </div>
      </div>
    </div>
  )
}
